import { Component, Input, OnChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {faEdit, faFileLines, faTrash, faUsers, faWarning} from '@fortawesome/free-solid-svg-icons';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-auth-report-list',
    templateUrl: './auth-report-list.component.html',
    styleUrls: ['./auth-report-list.component.scss'],
    standalone: false
})


export class AuthReportListComponent implements OnChanges {
  faEdit = faEdit;
  faUsers = faUsers;
  faWarning = faWarning;
  faFileLines = faFileLines;
  faTrash = faTrash;
  reports = new MatTableDataSource<any>();
  displayedColumns: string[] = ['filler', 'name', 'fill', 'total_req', 'total_auth', 'action'];

  @Input() assessment: any;
  @Input() isEditable!: boolean;
  @Input() user: any;
  @Input() reportList: any;

  constructor(
    public dialog: MatDialog,
  ) {
  }

  ngOnChanges(): void {
    this.loadData()
  }

  loadData() {
    let reports = this.reportList;
    if (reports) {
      reports.sort((reportA: any, reportB: any) => reportA.report_num - reportB.report_num)
      this.reports.data = reports;
    }
  }

  addSupportMessage(report: any) {
    if (report.supports?.length > 0) {
      let currentRequests = report.supports.filter((support: any) => {
        return !support.support_completed
      })
      if (currentRequests.length == 1) {
        let support = currentRequests[0]
        let skillsText = this.setSkillsText(support)
        let addDetailsText = ""
        if (support.additional_details) {
          addDetailsText = `\n\nAdditional Details:\n${support.additional_details}`
        }
        report.support_tooltip = `Interregional Support Request\n\nType of Support:\n${support.support_type} ${skillsText}${addDetailsText}`
      } else if (currentRequests.length > 1) {
        report.support_tooltip = `There are ${currentRequests.length} requests on this report. Visit the Teams tab to view the details.`
      }
    }
  }

  setSkillsText(support: any) {
    let skillsText = ""
    if (support.support_type == 'Team Member(s)' && support.support_skills != "") {
      let skills = support.support_skills.split(", ")
      if (skills.length == 1) {
        skillsText = support.support_skills
      } else if (skills.length == 2) {
        skillsText = skills.join(" and ")
      } else {
        skills[skills.length - 1] = "and " + skills[skills.length - 1]
        skillsText = skills.join(", ")
      }
      skillsText = "\n\nSkills:\n" + skillsText
    }
    return skillsText;
  }

  stopPropagation(event: any) {
    event.stopPropagation();
  }
}
